import { NgModule } from '@angular/core';
import { AbstractSecurityStorage, AuthModule, LogLevel, OpenIdConfiguration, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { AuthStorage } from 'src/app/auth/auth.storage';
import { Logs } from 'src/app/core/contracts';
import { isProd } from 'src/app/core/helpers/utils';
import { environment } from 'src/environments/environment';

const configureAuth = () => {
  const config: OpenIdConfiguration = {
    authority: environment.identityServer,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: 'agency-portal-code',
    scope: 'openid profile agency-api offline_access',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    renewUserInfoAfterTokenRenew: true,
    logLevel: isProd ? LogLevel.None : Logs.ENABLE_IDENTITY_SERVER_LOGS ? LogLevel.Debug : LogLevel.None,
    tokenRefreshInSeconds: 864000, // 10 days // TODO:auth revert to 60, fix auto renew on app startup up and update token lifetime on auth server,
    checkRedirectUrlWhenCheckingIfIsCallback: false, // setting to true will cause auth to fail on native as the current url uses a custom scheme that differs from the redirect url
    triggerAuthorizationResultEvent: true,
    /* triggerAuthorizationResultEvent can be set to true, which emits an event instead of an angular route change. Instead of forcing the application consuming this library to automatically redirect to one of the 3
       hard-configured routes (start, unauthorized, forbidden), this modification will add an extra configuration option to override such behavior and trigger an event that
       will allow to subscribe to it and let the application perform other actions. This would be useful to allow the application to save an initial return url so that the user is redirected
       to it after a successful login on the STS (i.e.: saving the return url previously on sessionStorage and then retrieving it during the triggering of the event). */

    /* silentRenewUrl: `${window.location.origin}/silent-renew.html`,
       postLoginRoute: '/home',
       forbiddenRoute: '/forbidden',
       unauthorizedRoute: '/unauthorized',
       autoUserinfo?: boolean, */
  };
  return new StsConfigStaticLoader(config);
};

@NgModule({
  imports: [
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: configureAuth,
      },
    }),
  ],
  providers: [{ provide: AbstractSecurityStorage, useClass: AuthStorage }],
  exports: [AuthModule],
})
export class AuthConfigModule {}
